import { render, staticRenderFns } from "./ViFeesType.vue?vue&type=template&id=fa08919e"
import script from "./ViFeesType.vue?vue&type=script&lang=js"
export * from "./ViFeesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports